import { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Alert } from '@mui/material';
import { useApi } from '../../../hooks/useApi';
import type { Enrolment } from '../../../types/alertEnrolment';

export default function EditNoteDialog({ enrolment, onClose, onSaved }: {
  enrolment: Enrolment | null; onClose: () => void; onSaved: (e: Enrolment) => void;
}) {
  const { patch, loading } = useApi();
  const [note, setNote] = useState('');
  const [error, setError] = useState<string | null>(null);
  useEffect(() => { setNote(enrolment?.note ?? ''); setError(null); }, [enrolment]);

  const save = async () => {
    if (!enrolment) return;
    setError(null);
    try {
      const updated = await patch<Enrolment>(`/api/alert-enrolments/${enrolment.id}`, { note });
      onSaved(updated); onClose();
    } catch (e: any) { setError(e.message ?? 'Failed to save note'); }
  };

  return (
    <Dialog open={Boolean(enrolment)} onClose={(_, r) => { if (r !== 'backdropClick') onClose(); }} fullWidth maxWidth="sm">
      <DialogTitle>Edit note — {enrolment?.ppAccountName}</DialogTitle>
      <DialogContent>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <TextField value={note} onChange={(e) => setNote(e.target.value)} placeholder="Add a note…" fullWidth multiline minRows={4} sx={{ mt: 1 }} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={save} disabled={loading}>Save note</Button>
      </DialogActions>
    </Dialog>
  );
}
